import { Component, h, Prop, Fragment } from '@stencil/core';

@Component({
  tag: 'app-launch-button',
  styleUrl: 'button.css',
  shadow: true,
})
export class Button {
  @Prop() variant: 'filled' | 'ghost';
  @Prop() isLink: boolean;
  @Prop() href?: string;
  @Prop() targetBlank?: boolean;
  @Prop() label: string;

  render() {
    return (
      <Fragment>
        {this.isLink ? (
          <a href={this.href} id="button" class={this.variant} target={this.targetBlank ? '_blank' : '_self'} rel={this.targetBlank ? 'noreferrer noopener' : ''}>
            <span id="label">{this.label}</span>
          </a>
        ) : (
          <button id="button" class={this.variant}>
            <label id="label">{this.label}</label>
          </button>
        )}
      </Fragment>
    );
  }
}
